import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const StyledImg = styled.img`
  width: 214px;
  height: 121px;
  display: block;
  margin: 30px auto 50px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 10px auto 37px;
  }
`
const AddressContainer = styled.div`
  &&& {
    width: 100%;
    max-width: 400px;
    margin: 80px auto;
    position: relative;
    @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
      margin: 30px 0 37px 0;
    }
  }
`

const LEGEND_LINE_HEIGHT = 21

const AddressCard = styled.fieldset`
  width: 100%;
  border: 1px solid ${style(theme => theme.colors.ivory)};
  border-radius: ${style(theme => theme.borderRadius.large)};
  padding: ${25 - LEGEND_LINE_HEIGHT / 2}px 30px 25px;
  margin: 0;
  text-align: center;
`

const AddressHeader = styled.legend`
  margin: 0;
  font-size: 14px;
  line-height: ${LEGEND_LINE_HEIGHT}px;
  font-weight: 500;
  color: ${style(theme => theme.colors.slate)};
`

const AddressBody = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${style(theme => theme.colors.slate)};
`

const StyledButton = styled(Button)`
  font-weight: 600;
  width: 220px;
  margin: auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export { StyledImg, AddressContainer, AddressCard, AddressHeader, AddressBody, StyledButton }
